export const ROUTES = {
  HOME: '/app',
  LANDING: '/',
  AUTH: '/auth',
  PROFILE: '/profile',
  EDIT_PROFILE: '/profile/edit',
  GROUPS: '/groups',
  CREATE_GROUP: '/groups/create',
  YOUR_GROUPS: '/your-groups',
  TOURNAMENTS: '/tournaments',
  CREATE_TOURNAMENT: '/tournaments/create',
  MATCHES: '/matches',
  CREATE_MATCH: '/matches/create',
  FEED: '/feed',
  
  RANKINGS: '/rankings',
  
  SETTINGS: '/settings',
  PRIVACY_SETTINGS: '/settings/privacy',
  CHANGE_PASSWORD: '/settings/change-password',
  MESSAGES: '/messages',
  NOTIFICATIONS: '/notifications',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  CONTACT: '/contact',
  HELP: '/help',
  FEATURE_GUIDE: '/what-you-can-do',

  
  // Dynamic routes - functions that return paths
  GROUP_DETAIL: (groupId: string) => `/groups/${groupId}`,
  EDIT_GROUP: (groupId: string) => `/groups/${groupId}/edit`,
  GROUP_HALL_OF_FAME: (groupId: string) => `/groups/${groupId}/hall-of-fame`,
  GROUP_FEES: (groupId: string) => `/groups/${groupId}/fees`,
  GROUP_STATS: (groupId: string) => `/groups/${groupId}/stats`,
  GROUP_ANNOUNCEMENTS: (groupId: string) => `/groups/${groupId}/announcements`,
  GROUP_CREATE_TOURNAMENT: (groupId: string) => `/groups/${groupId}/create-tournament`,
  
  // Tournament specific routes
  TOURNAMENT_DETAIL: (tournamentId: string) => `/tournaments/${tournamentId}`,
  EDIT_TOURNAMENT: (tournamentId: string) => `/tournaments/${tournamentId}/edit`,
  
  // Group-context tournament routes
  GROUP_TOURNAMENT_DETAIL: (groupId: string, tournamentId: string) => `/groups/${groupId}/tournaments/${tournamentId}`,
  EDIT_GROUP_TOURNAMENT: (groupId: string, tournamentId: string) => `/groups/${groupId}/tournaments/${tournamentId}/edit`,
  
  // Match specific routes
  MATCH_DETAIL: (matchId: string) => `/matches/${matchId}`,
  CAPTURE_SCHEDULED_MATCH_SCORES: (scheduledMatchId: string) => `/matches/create?scheduledMatchId=${scheduledMatchId}`,
  
  // Profile routes
  USER_PROFILE: (userId: string) => `/user/${userId}`,
  PUBLIC_PROFILE: (userId: string) => `/user/${userId}`,
  
  // Messages routes
  GROUP_MESSAGES: (groupId: string) => `/messages/group/${groupId}`,
  USER_MESSAGES: (userId: string) => `/messages/user/${userId}`,
} as const;
